import { LightningElement, api } from "lwc";
import { getAssetsUrl } from "common/helpers";
import stencilImage from "./assets/stamp-stencil.png";

export default class StampCollectionStencil extends LightningElement {
  @api variant: string = "default";

  private get stencils() {
    return Array.from({ length: this.stencilLength }).map((_, i) => ({
      key: `stencil-${i}`,
    }));
  }

  private get stencilImage() {
    return getAssetsUrl(stencilImage);
  }

  private get oneRow() {
    return this.variant === "one-row";
  }

  private get stencilLength() {
    if (this.variant === "one-row") {
      return 4;
    }

    return 8;
  }
}
